import Vue from "vue"
import Vuex from "vuex"
import axios from "@/http/http.js"
Vue.use(Vuex)
import router from "@/router/router.js"

const store = new Vuex.Store({
    state: {
        role: 1,   // 管理員等級
        offset: 30,
        userInfo: {}
    },
    mutations: {
        setState (state, data) {
            state[data.key] = data.value
        },
        logout (state) {
            state.userInfo = {}
            router.replace("/login")
        }
    },
    actions: {
        // 獲取當前登錄的管理員信息
        initUserInfo (store) {
            let userId = localStorage.getItem("userId")
            if (userId) {
                axios({
                    url: "admin/user",
                    params: {
                        page: 1,
                        offset: 999999,
                        search: "",
                    }
                }).then(res => {
                    // console.log('admin', res)
                    if (res.data.data.user_list) {
                        res.data.data.user_list.forEach(item => {
                            if (item.uuid == userId) {
                                store.commit("setState", { key: "userInfo", value: item })
                            }
                        })
                    }
                })
            }
            let role_id = localStorage.getItem("role_id")
            if (role_id) {
                store.commit("setState", { key: "role", value: role_id * 1 })
            }
            
        },
    }
})

export default store